import React from "react";

/**
 * TableSkeleton — reusable shimmer rows shown while a list loads.
 * Renders `rows` x `cols` pulsing placeholder cells.
 */
const TableSkeleton = ({ rows = 6, cols = 6 }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r}>
        {Array.from({ length: cols }).map((__, c) => (
          <td key={c}>
            <span
              className="tm-skeleton"
              style={{
                display: "block",
                height: 16,
                borderRadius: 4,
                background:
                  "linear-gradient(90deg,#eceff1 25%,#f5f6f7 37%,#eceff1 63%)",
                backgroundSize: "400% 100%",
                animation: "tmShimmer 1.4s ease infinite",
              }}
            />
          </td>
        ))}
      </tr>
    ))}
    {/* Keyframes injected once; scoped by unique animation name. */}
    <style>{`@keyframes tmShimmer{0%{background-position:100% 50%}100%{background-position:0 50%}}`}</style>
  </>
);

export default TableSkeleton;
